/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Rust_Bear_BoltInputs */

const en_fair_rust_bear_bolt = /** @type {(inputs: Fair_Rust_Bear_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

const de_fair_rust_bear_bolt = /** @type {(inputs: Fair_Rust_Bear_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Fair_Rust_Bear_BoltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fair_rust_bear_bolt = /** @type {((inputs?: Fair_Rust_Bear_BoltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Rust_Bear_BoltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fair_rust_bear_bolt(inputs)
	return de_fair_rust_bear_bolt(inputs)
});